import './walletcard.css';

 export const CardDetailModal = ({ card, onClose }) => {
  if (!card) return null;

  return (
    <div className="wallet-card-modal-overlay" onClick={onClose}>
      <div
        className="wallet-card-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="wallet-card-modal-close" onClick={onClose}>
          &times;
        </button>

        <h2 className="wallet-card-modal-title">Editar tarjeta</h2>

        <div className="wallet-card-modal-form">
          <div className="wallet-card-modal-row">
            <label>Número de tarjeta</label>
            <div className="wallet-card-modal-card-number">
              <img src={card.brandImage} alt={card.brand} />
              <span>{card.maskedNumber}</span>
            </div>
          </div>

          <div className="wallet-card-modal-row">
            <label>Fecha vencimiento</label>
            <input type="text" defaultValue={card.expiration} />
          </div>

          <div className="wallet-card-modal-row">
            <label>CVV</label>
            <input type="text" defaultValue="123" />
          </div>

          <div className="wallet-card-modal-row">
            <label>País</label>
            <select defaultValue={card.country}>
              <option value="Chile">Chile</option>
              <option value="Venezuela">Venezuela</option>
              <option value="Argentina">Argentina</option>
              {/* Agrega más si necesitas */}
            </select>
          </div>

          <div className="wallet-card-modal-row">
            <label>Nombre de la tarjeta (Opcional)</label>
            <input type="text" defaultValue={card.nickname} />
          </div>

          <div className="wallet-card-modal-info">
            <span className="wallet-card-modal-icon">ⓘ</span>
            Tu información bancaria es completamente privada. Open Matic no almacena los datos de tu tarjeta; el proceso de pago se gestiona de forma segura a través de Transbank.
          </div>

          <div className="wallet-card-modal-favorite">
            <input type="checkbox" id="favorite" defaultChecked={card.isFavorite} />
            <label htmlFor="favorite">Establecer como tarjeta favorita</label>
          </div>

          <button className="wallet-card-modal-save">Guardar</button>
        </div>
      </div>
    </div>
  );
};

